import React from "react";

function IconBase({ className, size = 16, children, ...rest }) {
  return (
    <svg
      className={className}
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      aria-hidden
      {...rest}
    >
      {children}
    </svg>
  );
}

export function IconArrowRight({ className, size }) {
  return (
    <IconBase className={className} size={size}>
      <path d="M5 12h14" />
      <path d="m12 5 7 7-7 7" />
    </IconBase>
  );
}

export function IconTrendingUp({ className, size }) {
  return (
    <IconBase className={className} size={size}>
      <polyline points="22 7 13.5 15.5 8.5 10.5 2 17" />
      <polyline points="16 7 22 7 22 13" />
    </IconBase>
  );
}

export function IconTrendingDown({ className, size }) {
  return (
    <IconBase className={className} size={size}>
      <polyline points="22 17 13.5 8.5 8.5 13.5 2 7" />
      <polyline points="16 17 22 17 22 11" />
    </IconBase>
  );
}

export function IconBot({ className, size }) {
  return (
    <IconBase className={className} size={size}>
      <path d="M12 8V4H8" />
      <rect width="16" height="12" x="4" y="8" rx="2" />
      <path d="M2 14h2" />
      <path d="M20 14h2" />
      <path d="M15 13v2" />
      <path d="M9 13v2" />
    </IconBase>
  );
}

export function IconUsers({ className, size }) {
  return (
    <IconBase className={className} size={size}>
      <path d="M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2" />
      <circle cx="9" cy="7" r="4" />
      <path d="M22 21v-2a4 4 0 0 0-3-3.87" />
      <path d="M16 3.13a4 4 0 0 1 0 7.75" />
    </IconBase>
  );
}

export function IconLayers({ className, size }) {
  return (
    <IconBase className={className} size={size}>
      <path d="m12.83 2.18a2 2 0 0 0-1.66 0L2.6 6.08a1 1 0 0 0 0 1.83l8.58 3.91a2 2 0 0 0 1.66 0l8.58-3.9a1 1 0 0 0 0-1.83Z" />
      <path d="m22 12.65-9.17 4.16a2 2 0 0 1-1.66 0L2 12.65" />
      <path d="m22 17.65-9.17 4.16a2 2 0 0 1-1.66 0L2 17.65" />
    </IconBase>
  );
}

export function IconLineChart({ className, size }) {
  return (
    <IconBase className={className} size={size}>
      <path d="M3 3v16a2 2 0 0 0 2 2h16" />
      <path d="m19 9-5 5-4-4-3 3" />
    </IconBase>
  );
}

export function IconShieldCheck({ className, size }) {
  return (
    <IconBase className={className} size={size}>
      <path d="M20 13c0 5-3.5 7.5-7.66 8.95a1 1 0 0 1-.67-.01C7.5 20.5 4 18 4 13V6a1 1 0 0 1 1-1c2 0 4.5-1.2 6.24-2.72a1.17 1.17 0 0 1 1.52 0C14.51 3.81 17 5 19 5a1 1 0 0 1 1 1z" />
      <path d="m9 12 2 2 4-4" />
    </IconBase>
  );
}

export function IconZap({ className, size }) {
  return (
    <IconBase className={className} size={size}>
      <path d="M4 14a1 1 0 0 1-.78-1.63l9.9-10.2a.5.5 0 0 1 .86.46l-1.92 6.02A1 1 0 0 0 13 10h7a1 1 0 0 1 .78 1.63l-9.9 10.2a.5.5 0 0 1-.86-.46l1.92-6.02A1 1 0 0 0 11 14z" />
    </IconBase>
  );
}

export function IconSparkles({ className, size }) {
  return (
    <IconBase className={className} size={size}>
      <path d="M9.937 15.5A2 2 0 0 0 8.5 14.062l-6.135-1.582a.5.5 0 0 1 0-.962L8.5 9.936A2 2 0 0 0 9.937 8.5l1.582-6.135a.5.5 0 0 1 .962 0L14.063 8.5A2 2 0 0 0 15.5 9.937l6.135 1.581a.5.5 0 0 1 0 .964L15.5 14.063a2 2 0 0 0-1.437 1.437l-1.582 6.135a.5.5 0 0 1-.964 0z" />
      <path d="M20 3v4" />
      <path d="M22 5h-4" />
      <path d="M4 17v2" />
      <path d="M5 18H3" />
    </IconBase>
  );
}

export function IconTrophy({ className, size }) {
  return (
    <IconBase className={className} size={size}>
      <path d="M6 9H4.5a2.5 2.5 0 0 1 0-5H6" />
      <path d="M18 9h1.5a2.5 2.5 0 0 0 0-5H18" />
      <path d="M4 22h16" />
      <path d="M10 14.66V17c0 .55-.47.98-.97 1.21C7.85 18.75 7 20.24 7 22" />
      <path d="M14 14.66V17c0 .55.47.98.97 1.21C16.15 18.75 17 20.24 17 22" />
      <path d="M18 2H6v7a6 6 0 0 0 12 0V2Z" />
    </IconBase>
  );
}

export function IconLayoutDashboard({ className, size }) {
  return (
    <IconBase className={className} size={size}>
      <rect width="7" height="9" x="3" y="3" rx="1" />
      <rect width="7" height="5" x="14" y="3" rx="1" />
      <rect width="7" height="9" x="14" y="12" rx="1" />
      <rect width="7" height="5" x="3" y="16" rx="1" />
    </IconBase>
  );
}

export function IconCompass({ className, size }) {
  return (
    <IconBase className={className} size={size}>
      <circle cx="12" cy="12" r="10" />
      <polygon points="16.24 7.76 14.12 14.12 7.76 16.24 9.88 9.88 16.24 7.76" />
    </IconBase>
  );
}

export function IconChevronRight({ className, size }) {
  return (
    <IconBase className={className} size={size}>
      <path d="m9 18 6-6-6-6" />
    </IconBase>
  );
}

/**
 * Gemini-style AI sparkle — copied from spikex-ai-web/components/icons/SparkleAI.tsx
 * Fills with currentColor (pass brand class for green).
 */
export function IconSparkleAI({ className, size = 24, outline = false }) {
  const color = "currentColor";
  return (
    <svg
      className={className}
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill={outline ? "none" : color}
      stroke={color}
      strokeWidth={outline ? 1.5 : 0.9}
      strokeLinejoin="round"
      strokeLinecap="round"
      aria-hidden
    >
      {/* big star — center (10,13) */}
      <path d="M10 5 Q11.77 11.23 18 13 Q11.77 14.77 10 21 Q8.23 14.77 2 13 Q8.23 11.23 10 5 Z" />
      {/* small star — center (18.5,6), top-right */}
      <path d="M18.5 2.5 Q19.27 5.23 22 6 Q19.27 6.77 18.5 9.5 Q17.73 6.77 15 6 Q17.73 5.23 18.5 2.5 Z" />
    </svg>
  );
}
